import { CheckCircle2, FileDown } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

export function AuraHeaderBar() {
  const { toast } = useToast();

  const handleExportToManus = () => {
    toast({
      title: "Export queued",
      description: "Your design export has been queued for processing.",
    });
  };

  return (
    <header className="sticky top-0 z-40 bg-white/70 backdrop-blur-sm border-b border-slate-200">
      <div className="max-w-4xl mx-auto px-5 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="/lovable-uploads/bbc133b7-6cd1-44ba-941b-2340e4755a16.png" 
            alt="No Doubles Golf Co." 
            className="h-8 w-auto"
          />
          <div className="text-[15px] text-slate-600 font-medium">No Doubles</div>
        </div>
        
        <div className="flex items-center gap-2">
          <span className="px-2.5 py-1 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 text-xs font-medium">
            Improved Design
          </span>
          <span className="px-2.5 py-1 rounded-full border border-slate-200 bg-white text-slate-700 text-xs font-medium">
            Mockups
          </span>
          <span className="hidden sm:inline-flex items-center gap-1 px-2.5 py-1 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 text-xs font-medium">
            <CheckCircle2 className="h-3.5 w-3.5" />
            Stack OK
          </span>
          
          <button
            onClick={handleExportToManus}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-emerald-200 bg-emerald-50 text-emerald-800 text-sm font-medium hover:bg-emerald-100 active:bg-emerald-100 transition focus:outline-none focus:ring-2 focus:ring-emerald-500/40 focus:ring-offset-1"
          >
            <FileDown className="h-4 w-4 text-emerald-700" />
            <span className="tracking-tight">Export to Manus</span>
          </button>
        </div>
      </div>
    </header>
  );
}